import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaidIcon(props: IconProps) {
    return <Icon {...props} iconKey={"paid"}/>
}
